import React from 'react'
import { Heading } from '@scentregroup/ui'
import TradingHoursLine, { themeTypes } from '../trading-hours-line'
import { SEE_MORE_HOURS_TEXT } from '../../constants'
import ShowMore from '../show-more'

import { parseCentreOpeningHours } from '../../helpers/parse-opening-hours'
import { RawOpeningHours } from '../../../types/contentful-v1'
import { useEvolvedContext } from '../../context'
import style from './index.module.scss'

export interface TradingHoursListProps {
  heading?: string
  openHoursHeading: string
  centreTradingHours: RawOpeningHours
  minDays: number
}

function hasHours(
  centreTradingHours: TradingHoursListProps['centreTradingHours']
): boolean {
  return (
    Boolean(centreTradingHours) &&
    Boolean(centreTradingHours.tradingHours) &&
    Boolean(centreTradingHours.timeZone)
  )
}

const TradingHoursList: React.FC<TradingHoursListProps> = ({
  heading,
  openHoursHeading,
  centreTradingHours,
  minDays,
}): JSX.Element | null => {
  const isEvolved = useEvolvedContext()

  if (hasHours(centreTradingHours)) {
    const openHours = parseCentreOpeningHours(
      centreTradingHours.tradingHours,
      centreTradingHours.timeZone,
      centreTradingHours.features
    )
    return (
      <div>
        {heading && <Heading type="medium">{heading}</Heading>}
        <div className={style.TradingHoursList}>
          <div className={style.tableHeading}>
            <Heading type="extrasmall" className={style.day}>
              Day
            </Heading>
            <Heading type="extrasmall" className={style.hours}>
              {openHoursHeading}
            </Heading>
          </div>
          <ShowMore
            buttonFullWithOnMobile={isEvolved}
            minItems={minDays}
            buttonText={SEE_MORE_HOURS_TEXT}
          >
            {openHours.map(hours => (
              <TradingHoursLine
                openHourDay={hours}
                theme={themeTypes.fiftyFifty}
                key={hours.day}
              />
            ))}
          </ShowMore>
        </div>
      </div>
    )
  }
  return null
}

export default TradingHoursList
